const helper = {
  modify_backtest_params: ({ data, name = "name" }) => {
    let arr = [];
    if (data && data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        let obj = {};
        obj[name] = data[i][0];
        obj["min"] = data[i][1];
        obj["max"] = data[i][2];

        arr.push(obj);
      }
    }
    return arr;
  },
  filterData: ({ data }) => {
    let x = [];
    if (!data) return x;
    for (let i in data) {
      var obj = {};

      let {
        scenario_name,
        scenario_id,
        type,
        bm_annualized_return,
        fund_annualized_return,
        alpha,
        beta,
        sortino_ratio,
        benchmark_name,
        benchmark,
        scn_status,
        client_portfolio_id,
      } = data[i];

      obj["scenario_id"] = scenario_id;
      obj["type"] = type;
      obj["bm_annualized_return"] = bm_annualized_return;
      obj["fund_annualized_return"] = fund_annualized_return;
      obj["scenario_name"] = scenario_name;
      obj["alpha"] = alpha;
      obj["beta"] = beta;
      obj["sortino_ratio"] = sortino_ratio;
      obj["benchmark_name"] = benchmark_name;
      obj["benchmark"] = benchmark;
      obj["scn_status"] = scn_status.toUpperCase();
      obj["client_portfolio_id"] = client_portfolio_id;
      x.push(obj);
    }
    return x;
  },
};
export default helper;



// WEBPACK FOOTER //
// ./src/components/pages/helper.modifyPortfolio.js